import { ApiLoginResponse, LoginRequest, LoginResponse } from './login.dto';
import apiFetch from '@/services/api';
import { REST_API_METHODS } from '@/constants';
import { renderRoute } from '@/helpers';
import { ROUTES } from '@/constants';

export async function adminLogin(
  credentials: LoginRequest
): Promise<LoginResponse> {
  const response = await apiFetch.request<ApiLoginResponse>(
    renderRoute(ROUTES.login, {}),
    {
      method: REST_API_METHODS.POST,
      body: JSON.stringify(credentials),
    }
  );

  // Transform the API response to match the expected format
  return {
    access_token: response.data.access_token,
    admin: {
      id: response.data.admin.id,
      email: response.data.admin.email,
      firstName: response.data.admin.firstName,
      lastName: response.data.admin.lastName,
      role: response.data.admin.role,
      isActive: response.data.admin.isActive,
    },
  };
}
